import { useState, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { authService } from '../../services/auth.service';
import { Input } from '../common/Input';
import { Button } from '../common/Button';

export function PasswordResetForm() {
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setIsLoading(true);

    try {
      await authService.forgotPassword(email);
      setSuccess(true);
      setEmail('');
    } catch (err) {
      setError(err instanceof Error ? err.message : t('resetPassword.resetFailed'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
          {error}
        </div>
      )}

      {success && (
        <div className="p-3 bg-green-50 border border-green-200 rounded text-green-700 text-sm">
          {t('resetPassword.successMessage')}
        </div>
      )}

      <Input
        type="email"
        label={t('resetPassword.email')}
        placeholder={t('resetPassword.emailPlaceholder')}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        autoComplete="email"
        helperText={t('resetPassword.emailHelp')}
      />

      <Button type="submit" className="w-full" loading={isLoading}>
        {t('resetPassword.sendButton')}
      </Button>
    </form>
  );
}
